import React from 'react';
import CustomCard from '../../../../../components/CustomCard';
import {
    IconHash,
    OutlinedCalendarIcon,
    PlusIconsOptions,
    TrashOutlineIcon,
} from '../../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../../components/CustomTooltip';
import CustomChip from '../../../../../components/CustomChip';
import { DATE_TIME_FORMAT_NAME_MODEL, getDateFormat } from '../../../../../Apis/functions';
import { colors } from '../../../../../enums/colors';
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
const CardItem = ({ card, t, isAssigned, onAdd, onRemove, disabled }) => {
    const handleAddClick = () => {
        if (disabled) return;
        onAdd?.(card);
    };
    return (
        <div className={`w-100 background-shades-50 border-radius-8px border-full-shades-300 p-0 ${disabled ? 'disable-card-item' : 'background-hover-shades-100' }`}>
            <div className='d-flex justify-content-between align-items-center h-100 p-3 gap-2'>
                {/* CONTENT */}
                <div className='flex-grow-1 minw-0'>
                    <div className='d-flex align-items-center minw-0'>
                        <div className='mr-2 flex-shrink-0'>
                            <IconHash />
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={card?.number}
                                classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row`}
                                showIfTruncated={true}
                            />
                        </div>
                    </div>
                    <div className='d-flex gap-2 mt-2 minw-0'>
                        <CustomChip
                            background={colors.secondary100}
                            borderColor={colors.secondary150}
                            fontColor={colors.secondary700}
                            legend={
                                <CustomTooltip
                                    text={`${t('facilityCode')}: ${card?.facilityCode}`}
                                    classes={`fs-12px text-ellipsis-1-row`}
                                    showIfTruncated={true}
                                />
                            }
                            className={"flex-grow-0 minw-0"}
                        />

                        <CustomChip
                            background={colors.secondary100}
                            borderColor={colors.secondary150}
                            fontColor={colors.secondary700}
                            legend={
                                <CustomTooltip
                                    text={`${t('format')}: ${card?.cardTypeName}`}
                                    classes={`fs-12px text-ellipsis-1-row`}
                                    showIfTruncated={true}
                                />
                            }
                            className={"flex-grow-0 minw-0"}
                        />
                    </div>
                    <div className='border-bottom-shades-300 my-2' />
                    <div className='d-flex align-items-center gap-2 minw-0'>
                        <div className='flex-shrink-0'>
                            <OutlinedCalendarIcon className='h-16px w-16px' />
                        </div>
                        <div className={'flex-grow-1 minw-0 font-color-shades-800 fs-14px ibl-font-w-400'}>
                            {t('created')}{' '}
                            {getDateFormat(card?.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                    </div>
                </div>

                <div className='d-flex align-items-center justify-content-center flex-shrink-0'>
                    {!isAssigned && (
                        <PlusIconsOptions
                            className={`icon-color-shades-400 ${!disabled ? 'icon-hover-shades-950' : 'opacity-50 cursor-not-allowed'}`}
                            onClick={handleAddClick}
                        />
                    )}

                    {isAssigned && (
                        <TrashOutlineIcon className='icon-color-shades-400' onClick={() => onRemove?.(card)} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardItem;
